
<pagination-template
  id="pagination"
  class="pagination_container"
  #p="paginationApi"
  (pageChange)="pageChange.emit($event)"
  >
  @if (displayTotal) {
    <div class="pagination-totals">
      <strong>{{ getFirstItem(p.getCurrent()) }}</strong> - <strong>{{ getLastItem(p.getCurrent(), p.getTotalItems()) }}</strong> out of <strong>{{p.getTotalItems()}}</strong> items
    </div>
  }
  <div class="pagination-previous" [class.disabled]="p.isFirstPage()" (click)="p.setCurrent(0)">
    <a><<</a>
  </div>
  <div class="pagination-previous" [class.disabled]="p.isFirstPage()" (click)="p.previous()">
    <a><</a>
  </div>
  @for (page of p.pages; track page) {
    <div
      [class.current]="p.getCurrent() === page.value"
      >
      <div class="pagination-page-number"
        (click)="p.setCurrent(page.value)">
        <span>{{ page.label }}</span>
      </div>
    </div>
  }
  <div class="pagination-next" [class.disabled]="p.isLastPage()" (click)="p.next()">
    <a>></a>
  </div>
  <div class="pagination-last" [class.disabled]="p.isLastPage()" (click)="p.setCurrent(p.getLastPage())">
    <a>>></a>
  </div>
</pagination-template>